import { getAnalytics, logEvent } from "firebase/analytics"
import { initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"

const config =
  process.env.REACT_APP_PROJECT === "prod"
    ? {
        apiKey: "AIzaSyDFjui-dIz0bVa7Z5xowuNlTVf1okDI6tA",
        authDomain: "dsm-app-prod.firebaseapp.com",
        projectId: "dsm-app-prod",
        storageBucket: "dsm-app-prod.appspot.com",
        messagingSenderId: "1000954748368",
        appId: "1:1000954748368:web:cbac65dfd793e938feedd5",
        measurementId: "G-T7JZXSVZGW",
      }
    : {
        apiKey: "AIzaSyCADw2Ir5tUXjhQOmbncpPTIz11Siq8ofA",
        authDomain: "dsm-app-dev.firebaseapp.com",
        projectId: "dsm-app-dev",
        storageBucket: "dsm-app-dev.appspot.com",
        messagingSenderId: "1087856592919",
        appId: "1:1087856592919:web:1eefd07b98dba1f72ff452",
        measurementId: "G-8N7PSPDDXK",
      }

const app = initializeApp(config)

export const fbAuth = getAuth(app)

const fbAnalytics = getAnalytics(app)
fbAnalytics.app.automaticDataCollectionEnabled = true

export const analytics = {
  logScreen: (name: string) =>
    logEvent(fbAnalytics, "appSupportVisit", { screen: name }),
}
